export default function (string: string) {
  return string.replace(/^./, string[0].toUpperCase());
}
